import { Box, IconButton } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import React from 'react'
import { GridToolbar } from '../../../components/GridToolbar/GridToolbar'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { dataColumn } from '../../../components/DataColumn'
import { Delete } from '@mui/icons-material'
import BankAddDialog from './BankAddDialog'
import { useEffect } from 'react'
import { useGetSupplierBankQuery, usePostSupplierMutation, useSubmitSupplierMutation } from '../../../store/api/supplierEvaluationApi'
import { showErrorToast, showSuccessToast, showWarningToast } from '../../../constToast/constToast'
import SaveDialog from '../../../components/Dialog/SaveDialog'
import { nextStep, offNextButton } from '../../../store/slice/buttonSlice'
import SupLoading from '../../../components/Loading/SupLoading'
import { updateSupNextButtonLoading } from '../../../store/slice/otherSlice'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { hideSubmitDialog } from '../../../store/slice/dialogSlice'
import SubmitDialog from '../../../components/Dialog/SubmitDialog'

export default function BankAccountSup({ companyData, ndaData, cobcData, tableData, setTableData,
  reviseSup, vendorId, country }) {

  const { data, isLoading } = useGetSupplierBankQuery(vendorId);
  const [saveMutation] = usePostSupplierMutation();
  const { t } = useTranslation('supplier')

  useEffect(() => {
    if (tableData?.length > 0) {
      setTableData(tableData)
    }
    else if (!isLoading && data?.data?.bankDetails?.length > 0) {
      setTableData(data?.data.bankDetails)
    } else {
      setTableData([])
    }

  }, [data, setTableData, isLoading])


  // Size
  const gridSize = useSelector((state) => state.dataGridSlice.size)

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleSave = async () => {
    const updatedItemsNda = ndaData.map(item => {
      return { ...item, vendorId: reviseSup ? 0 : vendorId };
    });

    const updatedItemsCobc = cobcData.map(item => {
      return { ...item, vendorId: reviseSup ? 0 : vendorId };
    });

    const updatedBankAccount = tableData.map(item => {
      return { ...item, vendorId: reviseSup ? 0 : vendorId };
    });

    const saveData = await saveMutation({
      companyInformation: {
        ...companyData,
        vendorId: reviseSup ? 0 : vendorId
      },
      nonDisclosureAgreement: updatedItemsNda,
      codeOfBuConduct: updatedItemsCobc,
      bankAccounts: updatedBankAccount,
      isRevise: reviseSup
    });

    if (saveData?.data?.statusCode === 200) {
      showSuccessToast(`Succesfully saved`)
      // setTableData(saveData?.data?.data?.bankDetails?.bankDetails)
      // setEditData(saveData?.data?.data?.bankDetails?.bankDetails)
    } else { showErrorToast('Error') }
  }
  const columns = [
    {
      field: 'actions',
      headerName: 'Actions',
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        return (
          <>
            <IconButton onClick={() => handleRowDelete(params.row.id)} sx={{ p: 0, marginLeft: 0.3 }} >
              <Delete sx={{ color: 'red' }} style={{ color: 'red' }} />
            </IconButton>
          </>
        )
      },
    },

    dataColumn('accountNumber', t('bankAccountNumber'), 200, ''),
    dataColumn('currency', t('currency'), 150, ''),
    dataColumn('beneficiary', t('beneficiary'), 200),
  ];


  const [editData, setEditData] = useState([])
  const [doubleClickBool, setDoubleClickBool] = useState(false)


  const handleDoubleClick = (params) => {
    setEditData(params.row)

    handleClickOpen();
    setDoubleClickBool(true)
  }


  const handleClose = () => {
    setOpen(false);

    setDoubleClickBool(false)
    setEditData([])
  };

  const handleRowDelete = (id) => {
    setTableData((prevTableData) =>
      prevTableData.map((row) => {
        if (row.id === id) {
          return { ...row, type: 2 };
        }
        return row;
      })
    );
  }

  const nextClicked = useSelector((state) => state.buttonSlice.nextClicked)

  const dispatch = useDispatch();
  useEffect(() => {
    if (nextClicked) {
      dispatch(offNextButton())
      if (tableData?.filter((row) => row.type === 0)?.length > 0) {
        dispatch(nextStep())
        dispatch(updateSupNextButtonLoading(true))
      }
      else {
        showWarningToast(t('bankWarning'))
      }
    }
  }, [tableData, dispatch, nextClicked])


  useEffect(() => {
    if (!isLoading) {
      dispatch(updateSupNextButtonLoading(false))
    }
  }, [isLoading, dispatch])

  //
  const navigate = useNavigate();

  const [submitMutation] = useSubmitSupplierMutation();
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const handleSubmit = async () => {
    const updatedItemsNda = ndaData.map(item => {
      return { ...item, vendorId: 0 };
    });

    const updatedItemsCobc = cobcData.map(item => {
      return { ...item, vendorId: 0 };
    });

    const updatedBankAccount = tableData.map(item => {
      return { ...item, vendorId: 0 };
    });

    setLoadingSubmit(true)

    const saveData = await submitMutation({
      companyInformation: {
        ...companyData,
        vendorId: 0
      },
      nonDisclosureAgreement: updatedItemsNda,
      codeOfBuConduct: updatedItemsCobc,
      bankAccounts: updatedBankAccount,
      dueDiligence: [],
      isRevise: false,
      isSubmitted: true
    });

    if (saveData?.data?.statusCode === 200) {
      showSuccessToast(`Succesfully submitted Vendor Code: ${saveData?.data?.data?.companyInformation?.vendorCode}`)
      setLoadingSubmit(false)
      navigate(`/waiting`)
      window.location.reload();
    } else if (saveData?.error?.status === 422) {
      showWarningToast(saveData?.error?.data?.errors)
    } else {
      showErrorToast('Error')
      setLoadingSubmit(false)
    }

    dispatch(hideSubmitDialog());
    setLoadingSubmit(false)
  }


  return (
    <>
      {!isLoading ? (
        <>
          <Box sx={{ height: 500, width: '100%' }}>
            <DataGrid
              rows={tableData?.filter((row) => row.type === 0)}
              columns={columns}
              getRowId={row => row.id}
              density={gridSize}
              rowHeight={35}
              onRowDoubleClick={handleDoubleClick}
              showCellRightBorder
              components={{
                Toolbar: () => (
                  <GridToolbar
                    hiddenSearch={false}
                    handleAddRow={handleClickOpen}
                    hiddenRefresh={true}
                  />
                ),
              }}
            />
          </Box>
          <BankAddDialog open={open}
            handleClose={handleClose}
            doubleClickBool={doubleClickBool}
            editData={editData}
            vendorId={vendorId}
            setTableData={setTableData} tableData={tableData}
            currencies={data?.data?.currencies}
            country={country} />
          <SaveDialog handleSave={handleSave} text='Bank Account' />
          <SubmitDialog handleSubmit={handleSubmit} text='Submit' loadingSubmit={loadingSubmit} />
        </>
      ) : <><SupLoading /></>}

    </>
  )
}

